import React, { SVGProps } from "react";

export default function SupCopy(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.78571 7.33333C4.41878 7.33333 2.5 9.24359 2.5 11.6V13.7333C2.5 16.0897 4.41878 18 6.78571 18H8.92857C11.2955 18 13.2143 16.0897 13.2143 13.7333V12.6667C15.5812 12.6667 17.5 10.7564 17.5 8.4V2H11.0714C8.70449 2 6.78571 3.91025 6.78571 6.26667V7.33333ZM16.4286 3.06667H11.0714C9.29623 3.06667 7.85714 4.49936 7.85714 6.26667V7.33333H13.2143V11.6C14.9895 11.6 16.4286 10.1673 16.4286 8.4V3.06667ZM12.1429 8.4H6.78571C5.01051 8.4 3.57143 9.83269 3.57143 11.6V13.7333C3.57143 15.5006 5.01051 16.9333 6.78571 16.9333H8.92857C10.7038 16.9333 12.1429 15.5006 12.1429 13.7333V8.4Z"
        fill="currentColor"
      />
    </svg>
  );
}
